module.exports = __webpack_public_path__ + "static/cercazone_sudest1-2a9b977d7033cc54fe8b9b37b4996f25.jpg";